document.addEventListener('DOMContentLoaded', function() {
    function rearrangeMiniCart() {
        var cartProducts = document.querySelectorAll('#cart-info .ajaxcart__product');
        cartProducts.forEach(function(cartItem) {
            var price = cartItem.querySelector('.product-price');
            var bottom = cartItem.querySelector('.cart__item-bottom');
            var removeBtn = cartItem.querySelector('.remove-from-cart');
            
            if (price && bottom && removeBtn) {
                // Check if price is not inside bottom
                if (!bottom.contains(price)) {
                    bottom.appendChild(price);
                    bottom.classList.add('justify-content-between');
                }
                
                // Check if removeBtn is inside bottom
                if (bottom.contains(removeBtn)) {
                    cartItem.querySelector('.media-body').insertBefore(removeBtn, bottom);
                }
            }
        });
    }

    // Run initially just in case it's already there
    rearrangeMiniCart();

    // Setup MutationObserver to watch for AJAX cart updates
    var cartInfoNode = document.getElementById('cart-info');
    if (cartInfoNode) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length > 0) {
                    rearrangeMiniCart();
                }
            });
        });
        observer.observe(cartInfoNode, { childList: true, subtree: true });
    }
});
